import React, { useState } from "react";
import "./TrackOrder.scss";
import Accordion from "b2b-ui-components-lib/lib/components/accordion";
import Button from "b2b-ui-components-lib/lib/components/button";
import icProgress from "../../../assests/svg/ic_progress.svg";
import refresh from "../../../assests/svg/refresh.svg";

function TrackOrder() {
  const [accordionMetadata, setAccordionMetadata] = useState({});

  const headingTitle = () => (
    <div className="order_number">
      <span>Order Number: 21-3676330853609</span>
      <div className="item_name">Internet</div>
    </div>
  );
  return (
    <div className="track_section">
      <div className="b2b-lib-container">
        <div className="section">
          <div className="day_section">Today</div>
          <Accordion title={headingTitle()} isExpanded={true}>
            <div className="track_group">
              <div className="track_left">
                <div className="steps_status">
                  <div className="step_left">
                    <div className="step_header">
                      <div className="status_head">
                        <span>
                          <img src={icProgress} />
                        </span>
                        <div className="status_indication">Pending</div>
                        <div className="orderdetails">
                          Network availability check{" "}
                          <img src={refresh} className="refresh_btn" />
                        </div>
                      </div>
                    </div>
                    <div className="stepper_section">
                      <div className="step">
                        <div className="content">Order Placed</div>
                      </div>

                      <div className="step">
                        <div className="content">Pricing and Quotation</div>
                      </div>

                      <div className="step active">
                        <span className="border-circle"></span>
                        <div className="content">
                          Pending - Network availability check
                          <p className="progress_status">
                            <span>25 Aug 21, 11:05 am</span>
                          </p>
                        </div>
                        <div className="within-tat">
                          <Button buttonClass="within_text">Within TAT</Button>
                          <span>11:20 hrs remaining</span>
                        </div>
                      </div>

                      <div className="step">
                        <div className="content">Request Raised</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="track_right">
                <div className="details">
                  <div className="internet_value">
                    Internet <span className="site_number">1 Site</span>
                  </div>
                  <div className="plan_options">
                    <div className="plan_value">
                      <div className="plan_detail">
                        <b>&#8377;899</b> / per month
                      </div>
                      <div className="plan_features">
                        + 100 mpbs + Rollover Data{" "}
                        <span> one time installation charge &#8377;1000</span>
                      </div>
                    </div>
                    <Button buttonClass="call_kam">Call KAM</Button>
                  </div>
                  <div className="other_details">
                    <div className="image_box"></div>
                    <div className="request_details">
                      <ul>
                        <li className="column">
                          Request Type
                          <span>Revised</span>
                        </li>
                        <li className="column">
                          Request Raised on
                          <span>25 Jul, 21 - 11:05 am</span>
                        </li>
                        <li className="column">
                          Company Name
                          <span>HDFC Private Ltd.</span>
                        </li>
                        <li className="column">
                          Estimated Date
                          <span>20 May 21 - 02:09 pm</span>
                        </li>
                        <li className="column">
                          What to expect at the time of Delievery
                          <span>Set-up Box, loremp ipsum</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Accordion>

          <div className="day_section">Yesterday</div>
          <Accordion title={headingTitle()} isExpanded={true}>
            <div className="track_group">
              <div className="track_left">
                <div className="steps_status">
                  <div className="step_left">
                    <div className="step_header">
                      <div className="status_head">
                        <span>
                          <img src={icProgress} />
                        </span>
                        <div className="status_indication">Pending</div>
                        <div className="orderdetails">
                          Network availability check{" "}
                          <img src={refresh} className="refresh_btn" />
                        </div>
                      </div>
                    </div>
                    <div className="stepper_section">
                      <div className="step">
                        <div className="content">Order Placed</div>
                      </div>

                      <div className="step">
                        <div className="content">Pricing and Quotation</div>
                      </div>

                      <div className="step active">
                        <span className="border-circle"></span>
                        <div className="content">
                          Pending - Network availability check
                          <p className="progress_status">
                            <span>25 Aug 21, 11:05 am</span>
                          </p>
                        </div>
                        <div className="within-tat">
                          <Button buttonClass="within_text">Within TAT</Button>
                          <span>11:20 hrs remaining</span>
                        </div>
                      </div>

                      <div className="step">
                        <div className="content">Request Raised</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="track_right">
                <div className="details">
                  <div className="internet_value">
                    Internet <span className="site_number">1 Site</span>
                  </div>
                  <div className="plan_options">
                    <div className="plan_value">
                      <div className="plan_detail">
                        <b>&#8377;899</b> / per month
                      </div>
                      <div className="plan_features">
                        + 100 mpbs + Rollover Data{" "}
                        <span> one time installation charge &#8377;1000</span>
                      </div>
                    </div>
                    <Button buttonClass="call_kam">Call KAM</Button>
                  </div>
                  <div className="other_details">
                    <div className="image_box"></div>
                    <div className="request_details">
                      <ul>
                        <li className="column">
                          Request Type
                          <span>Revised</span>
                        </li>
                        <li className="column">
                          Request Raised on
                          <span>25 Jul, 21 - 11:05 am</span>
                        </li>
                        <li className="column">
                          Company Name
                          <span>HDFC Private Ltd.</span>
                        </li>
                        <li className="column">
                          Estimated Date
                          <span>20 May 21 - 02:09 pm</span>
                        </li>
                        <li className="column">
                          What to expect at the time of Delievery
                          <span>Set-up Box, loremp ipsum</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Accordion>

          <Accordion title={headingTitle()} isExpanded={true}>
            <div className="track_group">
              <div className="track_left">
                <div className="steps_status">
                  <div className="step_left">
                    <div className="step_header">
                      <div className="status_head">
                        <span>
                          <img src={icProgress} />
                        </span>
                        <div className="status_indication">Pending</div>
                        <div className="orderdetails">
                          Network availability check{" "}
                          <img src={refresh} className="refresh_btn" />
                        </div>
                      </div>
                    </div>
                    <div className="stepper_section">
                      <div className="step">
                        <div className="content">Order Placed</div>
                      </div>

                      <div className="step">
                        <div className="content">Pricing and Quotation</div>
                      </div>

                      <div className="step active">
                        <span className="border-circle"></span>
                        <div className="content">
                          Pending - Network availability check
                          <p className="progress_status">
                            <span>25 Aug 21, 11:05 am</span>
                          </p>
                        </div>
                        <div className="within-tat">
                          <Button buttonClass="within_text">Within TAT</Button>
                          <span>11:20 hrs remaining</span>
                        </div>
                      </div>

                      <div className="step">
                        <div className="content">Request Raised</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="track_right">
                <div className="details">
                  <div className="internet_value">
                    Internet <span className="site_number">1 Site</span>
                  </div>
                  <div className="plan_options">
                    <div className="plan_value">
                      <div className="plan_detail">
                        <b>&#8377;899</b> / per month
                      </div>
                      <div className="plan_features">
                        + 100 mpbs + Rollover Data{" "}
                        <span> one time installation charge &#8377;1000</span>
                      </div>
                    </div>
                    <Button buttonClass="call_kam">Call KAM</Button>
                  </div>
                  <div className="other_details">
                    <div className="image_box"></div>
                    <div className="request_details">
                      <ul>
                        <li className="column">
                          Request Type
                          <span>Revised</span>
                        </li>
                        <li className="column">
                          Request Raised on
                          <span>25 Jul, 21 - 11:05 am</span>
                        </li>
                        <li className="column">
                          Company Name
                          <span>HDFC Private Ltd.</span>
                        </li>
                        <li className="column">
                          Estimated Date
                          <span>20 May 21 - 02:09 pm</span>
                        </li>
                        <li className="column">
                          What to expect at the time of Delievery
                          <span>Set-up Box, loremp ipsum</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Accordion>
        </div>
      </div>
    </div>
  );
}
export default TrackOrder;
